"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
export default function HeroSection() {
  const $ = _c(32);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 50
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br className="hidden lg:block" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t6 = <motion.h1 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="mb-5 font-poppins text-[32px] font-bold leading-[1.2] tracking-tight text-[#050748] sm:text-[40px] lg:text-[56px] dark:text-white">{"Doctor OPD Management & "}{t5} Appointment Booking CRM</motion.h1>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="mb-8 max-w-2xl text-base leading-relaxed text-gray-500 lg:text-lg dark:text-gray-400">Boost your clinic's efficiency with our Doctor OPD Management and Appointment Booking CRM. Streamline scheduling, patient management, and consultations seamlessly.</p>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <GradientButton href="/contact" variant="peach-pink">Contact Us Now <FaChevronRight className="ml-1 text-[12px]" /></GradientButton>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6) {
    t9 = <div className="mb-12 flex w-full flex-1 flex-col items-center text-center">{t6}{t7}{t8}</div>;
    $[15] = t6;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[17] = desktopAnimations;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== desktopAnimations) {
    t11 = desktopAnimations ? {
      opacity: 1
    } : undefined;
    $[19] = desktopAnimations;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== desktopAnimations) {
    t12 = desktopAnimations ? undefined : {
      opacity: 1
    };
    $[21] = desktopAnimations;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      duration: 0.6
    };
    t14 = {
      once: true
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t13 = $[23];
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12) {
    t15 = <div className="relative flex w-full flex-1 justify-center"><motion.img initial={t10} whileInView={t11} animate={t12} transition={t13} viewport={t14} src="/images/dr-crm/dr-crm-dashboard.png" alt="Doctor OPD Management CRM Dashboard" className="animate-[float_4s_ease-in-out_infinite] h-auto w-full max-w-[900px] object-contain drop-shadow-2xl" /></div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t9) {
    t16 = <section className="relative -mt-20 overflow-hidden bg-gradient-to-br bg-[url('/images/background/bg-light.png')] from-[#fff7f0] via-[#fffbf9] to-[#fbf0f5] bg-cover bg-top bg-no-repeat pt-32 font-sans sm:pt-36 lg:pt-44 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950 dark:bg-none"><div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-center px-6 pb-20 lg:px-12">{t9}{t15}</div></section>;
    $[29] = t15;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}